import { useMemo } from 'react';
import { breakpointSizes } from '@view/theme/foundations/breakpoints';
import { useWindowSize } from '@view/hooks/useWindowSize';
export const useViewportSize = () => {
    const { width, height } = useWindowSize();
    const isDomReady = useMemo(() => height > 0 && width > 0, [width, height]);
    const isMobile = width <= breakpointSizes.sm;
    const isMobileMd = width <= breakpointSizes.md;
    const isMobileLarge = width <= breakpointSizes.lg;
    const size = useMemo(() => {
        if (!isDomReady) {
            return null;
        }
        if (isMobile) {
            return 'sm';
        }
        if (isMobileMd) {
            return 'md';
        }
        return 'lg';
    }, [isDomReady, isMobile, isMobileMd]);
    return {
        height,
        isDomReady,
        isMobile,
        isMobileLarge,
        isMobileMd,
        size,
        width,
    };
};
